import React from "react";
import { bind } from "decko";
import { Modal } from 'react-bootstrap';
import GameEvent from "./include/GameEvent";
import Util from "./include/Util";

const gamePhaseMapping = [
    {
        field: 'start_time',
        text: 'not started',
        minimum: 0,
        maximum: 0,
    }, {
        field: 'start_of_1st_half',
        text: '1st half',
        minimum: 0,
        maximum: 60,
    }, {
        field: 'start_of_2nd_half',
        text: '2nd half',
        minimum: 45,
        maximum: 105,
    }, {
        field: 'start_of_1st_overtime',
        text: '1st overtime',
        minimum: 90,
        maximum: 120,
    }, {
        field: 'start_of_2nd_overtime',
        text: '2nd overtime',
        minimum: 105,
        maximum: 135,
    }, {
        field: 'start_of_penalties',
        text: '2nd overtime',
        minimum: 120,
        maximum: 200,
    },
];

function getExistingGamePhases (game) {
    return gamePhaseMapping.reduce((arr, mapping) => {
        if (game[mapping.field] !== null) {
            arr.push({
                text: mapping.text,
                minimum: mapping.minimum,
                maximum: mapping.maximum,
                timestamp: game[mapping.field],
            });
        }
        return arr;
    }, []);
}

export default class CreateNewLevel2Clip extends React.Component {

    constructor (props) {
        super(props);

        this.state = {
            errorMsg: null,
            game: null,
            tags: [],
            tag: "",
            phases: [],
            phase: {
                text: 'not started',
                minimum: 0,
                maximum: 0,
                timestamp: null,
            },
            gameMinute: 0,
            gameSecond: 0,
        }
    }

    loadTags (server) {
        server.get("/tag", ({tags}) => (
            this.setState({
                tags: Object.keys(tags),
            })
        ));
    }

    gameToString (gameContainer) {
        const game = gameContainer.game;
        if (game.home_team === null || game.visiting_team === null) return "unknown";
        let ts = new Date(game.start_time);
        return `${game.home_team.name} v ${game.visiting_team.name} | ${ts.toLocaleString()}`;
    }

    @bind
    onConfirm () {

        // Validate input
        if (this.state.game === null || this.state.tag === "") {
            //TODO display error
            this.setState({errorMsg: "Game or tag not set"});
            return;
        }

        this.setState({errorMsg: null});
        const server = this.state.game.server;
        const game = this.state.game.game;
        const timestamp = this.getTimestamp();

        server.get(`/game/${game.id}/videoassets`, ({videoassets, total}) => {

            console.log("Found", total, "assets from this game");

            // Filter the assets based on timestamp, in case there are more than 1
            // Find an asset that overlaps the desired timestamp
            let validAssets = videoassets.filter(asset => {
                let startTimestamp = new Date(asset.start_timestamp);
                let endTimestamp = new Date(asset.start_timestamp);
                endTimestamp = endTimestamp.setMilliseconds(
                    endTimestamp.getMilliseconds() + asset.duration_ms
                );
                return (startTimestamp <= timestamp && endTimestamp >= timestamp);
            });

            console.log("Found", validAssets.length, "valid assets");

            if (validAssets.length > 1) {
                // Prioritize live, then sort by duration. Grab the longest
                // Should have a more deterministic method...
                validAssets.sort((a, b) => (b.is_live - a.is_live) ||
                    (b.duration_ms - a.duration_ms));
            } else if (validAssets.length === 0) {
                this.setState({
                    errorMsg: "No video asset exists overlapping this timestamp.\n" +
                    "Ensure that the timestamp is not ahead of livestream and that game is/was streamed.\n" +
                    "In case of an earlier livestream crash, we could be missing segments here."
                });
                return;
            }

            let asset = validAssets[0];
            asset.server = server;
            let offsetSec = (timestamp - new Date(asset.start_timestamp)) / 1000;
            let tag = {'action': this.state.tag};

            const gameEvent = GameEvent.create(
                asset,
                offsetSec,
                tag,
                undefined,
                Util.createAutomaticTitle(tag, game),
                true
            );
            this.props.onCreate(gameEvent);
        });
    }

    setGame (gameContainer) {
        const game = gameContainer.game;
        const phases = getExistingGamePhases(game);
        const phaseIdx = phases.length > 1 ? 1 : 0;
        const phase = phases[phaseIdx];

        this.setState({
            errorMsg: null,
            game: gameContainer,
            phases: phases,
            phase: phase,
            gameMinute: phase.minimum,
            gameSecond: 0,
        }, this.updateStateFields);

        this.loadTags(gameContainer.server);
    }

    getTimestamp () {
        const phase = this.state.phase;
        const offset = (this.state.gameMinute - phase.minimum) * 60 + this.state.gameSecond;
        let ts = new Date(phase.timestamp);
        ts.setSeconds(ts.getSeconds() + offset);
        return ts;
    }

    @bind
    updateStateFields () {
        this.refs.gameMinuteField.value = this.state.phase.minimum;
        this.refs.gameSecondField.value = 0;
        this.updateTimestampField();
    }

    @bind
    updateTimestampField () {
        this.refs.timestampField.value = this.getTimestamp().toLocaleString();
    }

    @bind
    onChangeGameMinute (ev) {
        this.setState({
            gameMinute: parseInt(ev.target.value, 10),
        }, this.updateTimestampField);
    }

    @bind
    onChangeGameSecond (ev) {
        this.setState({
            gameSecond: parseInt(ev.target.value, 10),
        }, this.updateTimestampField);
    }

    @bind
    onChangePhase (ev) {
        let value = ev.target.value;
        let phase = this.state.phases.find(p => p.text === value);
        this.setState({
            phase: phase,
            gameMinute: phase.minimum,
            gameSecond: 0,
        }, this.updateStateFields)
    }

    @bind
    onChangeTag (ev) {
        this.setState({tag: ev.target.value});
    }

    renderBody () {

        let selectedGame = this.state.game === null ? null : this.state.game.key;
        let games = this.props.games.map(game => (
            <tr key={game.key}>
                <td>
                    <a className={"list-group-item" + ((game.key === selectedGame) ? " active":"")}
                       onClick={() => this.setGame(game)}>
                        {this.gameToString(game)}
                    </a>
                </td>
            </tr>
        ));

        const gameData = this.state.game ? this.state.game.game : null;

        return (
            <Modal.Body>
                <div className="create-clip-modal-games">
                    <b>Select game:</b>
                    <table className="table table-options-container">
                        <tbody>
                            {games}
                        </tbody>
                    </table>
                    {!this.state.game && (
                        <i><small>
                            Game not showing up? Ensure correct date in topleft
                        </small></i>
                    )}
                </div>
                {this.state.game && (
                    <fieldset className="create-clip-modal-form">
                        <div className="input-group fullwidth">
                            <select className="form-control"
                                    value={this.state.tag}
                                    onChange={this.onChangeTag}>
                                <option value="">
                                    Select event
                                </option>
                                {this.state.tags.map((tag) => (
                                    <option key={tag} value={tag}>
                                        {tag}
                                    </option>
                                ))}
                            </select>
                        </div>
                        { (this.state.tag !== "" && !Util.playlistShouldBePrivate(this.state.tag)) && (

                            <div className="col-xs-12">
                                <i><small>
                                    Note: The clip interval will be significantly longer than usual
                                    to easier locate the event. Make sure to trim the start/stop
                                    markers significantly.
                                </small></i>
                            </div>
                        )}
                    </fieldset>
                )}
                <fieldset className="create-clip-modal-form">
                    <table className={"table text-center" + (gameData===null?" hidden":"")}>
                        <tbody>
                            <tr>
                                <th>Phase</th>
                                <th>Minute</th>
                                <th>Second</th>
                            </tr>
                            <tr>
                                <td>
                                    <select className="form-control"
                                            value={this.state.phase.text}
                                            onChange={this.onChangePhase}
                                            ref="phaseField">
                                        {this.state.phases.map((phase) => (
                                            <option key={phase.text} value={phase.text}>
                                                {phase.text}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                                <td>
                                    <input className="form-control"
                                           type="number"
                                           step={1}
                                           min={this.state.phase.minimum}
                                           max={this.state.phase.maximum}
                                           onChange={this.onChangeGameMinute}
                                           ref="gameMinuteField"/>
                                </td>
                                <td>
                                    <input className="form-control"
                                           type="number"
                                           step={1}
                                           min={0}
                                           max={59}
                                           onChange={this.onChangeGameSecond}
                                           ref="gameSecondField"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </fieldset>
                <fieldset disabled>
                    <div className="input-group font-weight-bold">
                        <div className="input-group-addon">
                            <span className="input-group-text">
                                Timestamp:
                            </span>
                        </div>
                        <input type="text"
                               className="form-control"
                               ref="timestampField"
                               placeholder="Please first select a game..." />
                    </div>
                </fieldset>
            </Modal.Body>
        );
    }

    render () {
        const { onCancel } = this.props;

        return (
            <Modal
                show
                dialogClassName="create-clip-modal"
                onHide={onCancel}>
                <Modal.Header>
                    <Modal.Title>
                        Create new event
                    </Modal.Title>
                </Modal.Header>

                {this.renderBody()}

                {this.state.errorMsg && (
                    <div className="col-xs-12 modal-error-msg">
                        {this.state.errorMsg}
                    </div>
                )}

                <Modal.Footer>
                    <button
                        className="btn btn-default pull-left"
                        onClick={onCancel}>
                        Cancel
                    </button>
                    <button
                        className="btn btn-success"
                        onClick={this.onConfirm}>
                        Confirm
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/CreateNewLevel2Clip.js